import { render } from "./partners.vue?vue&type=template&id=0b68ed0a&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"

import "./partners.vue?vue&type=style&index=0&id=0b68ed0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b68ed0a"

export default script